import React, { FunctionComponent } from "react";
import { enums } from "../../../../../shim/jsbridge";
import Name from "../../../../search/schema/components/Name";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

type RlCloudSandboxMalwareConfigurationRedirectLinkProps = {
  url: string;
};

const RlCloudSandboxMalwareConfigurationRedirectLink: FunctionComponent<
  RlCloudSandboxMalwareConfigurationRedirectLinkProps
> = ({ url }) => (
  <Name data={{ file_name: url, int_submission_analyzer: URLANALYZER }} />
);

export default RlCloudSandboxMalwareConfigurationRedirectLink;
